import { ReferenceInput, SelectInput } from "ra-ui-materialui";

import React from "react";
import { get } from "lodash";
import { required } from "ra-core";

const StaffUserRoleInput = ({ ...props }) =>
  get(props, "record.type") === "public" ? (
    <ReferenceInput
      {...props}
      validate={required()}
      reference="staff-user-roles"
      filter={{
        research_project_id: get(props, "record.research_project_id", null),
      }}
    >
      <SelectInput optionText="name" />
    </ReferenceInput>
  ) : null;

export default StaffUserRoleInput;
